import { default as React, useEffect, useState } from 'react';

import {
  DevHubButton,
  DevHubCheckbox,
  DevHubDynamicIcon,
  DevHubMenu,
  DevHubMenuItem,
} from '@devxdiscover/devhub-ui';
import { Device } from '../types/InsightsTypes';

interface EnvButtonProps {
  env: string;
  selectedEnvs: string[];
  handleEnvChange: (status: string) => void;
}

const EnvironmentButton: React.FC<EnvButtonProps> = ({
  env,
  selectedEnvs,
  handleEnvChange,
}) => {
  const isSelected = selectedEnvs.includes(env);

  const handleClick = () => {
    handleEnvChange(env);
  };

  return (
    <DevHubMenuItem onClick={handleClick}>
      <DevHubCheckbox
        checked={isSelected}
        color="primary"
        inputProps={{ 'aria-label': env }}
      />
      {`${env}`}
    </DevHubMenuItem>
  );
};

interface Props {
  selectedEnvs: string[];
  deviceList: Device[];
  handleEnvChange: (env: string) => void;
}

/**
 * This is a component that displays a list of environments to be filtered
 * @param props - The props for the EnvironmentFilter component
 */
const EnvironmentFilter: React.FC<Props> = (props: Props) => {
  const { selectedEnvs, handleEnvChange } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [environments, setEnvironments] = useState<string[]>([]);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    const envs = [
      ...new Set(props.deviceList.map(device => device.environment)),
    ];
    setEnvironments(envs);
  }, [props.deviceList]);

  return (
    <div>
      <DevHubButton
        variant="outlined"
        height="large"
        aria-controls="status-menu"
        aria-haspopup="true"
        onClick={handleMenuOpen}
      >
        <DevHubDynamicIcon
          iconName="FilterList"
          style={{ marginRight: '.5rem' }}
        />
        Environment
      </DevHubButton>
      <DevHubMenu
        id="status-menu"
        getContentAnchorEl={null}
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        {environments.map((environment, idx) => (
          <EnvironmentButton
            key={idx}
            env={environment}
            selectedEnvs={selectedEnvs}
            handleEnvChange={handleEnvChange}
          />
        ))}
      </DevHubMenu>
    </div>
  );
};

export default EnvironmentFilter;
